/**
 * This file contains logic that supports the filtering of projects.
 */

import {
  getSelectedLicenseTypes,
  showProjectBasedOnLicenseType,
  updateLicenseTypeCounts
} from "../components/licenseTypeFilter";
import {
  getSelectedBibleTypes,
  showProjectBasedOnBibleType,
  setBibleTypeCounts
} from "../components/bibleTypeFilter";

import {
  getSelectedLanguages,
  showProjectBasedOnLanguage
} from "../components/languageFilter";

/**
 * Update the number of visible projects after a filter change.
 */
export function updateProjectCount() {
  const count = $('.products-list>li:visible').length;
  $('.text-result strong:first-child').text(String(count));
}

/**
 * Show or hide a project based on filter criteria.
 */
export function showHideProjects() {
  const selectedLicenseTypes = getSelectedLicenseTypes();
  const selectedBibleTypes = getSelectedBibleTypes();
  const selectedLanguages = getSelectedLanguages();

  $('.products-list>li').each(function () {
    let show = true;
    if (
      !showProjectBasedOnBibleType(this, selectedBibleTypes) ||
      !showProjectBasedOnLanguage(this, selectedLanguages) ||
      !showProjectBasedOnLicenseType(this, selectedLicenseTypes)
    ) {
      show = false;
    }
    if (show) {
      $(this).show();
    } else {
      $(this).hide();
    }
  })
  updateProjectCount();
}

/**
 * Handle the initialization for project list filtering.
 */
export function initListFilter() {
  setBibleTypeCounts();
  updateLicenseTypeCounts();
  $('input').on('change', showHideProjects);
  $('#bible-type-filter input').on('change', updateLicenseTypeCounts);
}
